import * as React from 'react';

import { createIcon } from '../Icon';
export const Navigation2Icon = createIcon(
  <polygon points="12 2 19 21 12 17 5 21 12 2" />,
  'Navigation2Icon'
);
